module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10232.13ce8d61.jpg";